import React from 'react';

import { Tabs, TabsContent, TabsList } from 'shadcn/components/ui/Tabs';

import { ManageSKUBudgets } from '../ManageSKUBudgets';
import { MFCAllocationTool } from '../MFCAllocationTool';
import { OverviewAllocation } from '../OverviewAllocation';

import { TabButton } from './components/TabButton';

/**
 * Navigation tabs for Inventory Separation dashboard
 * Manages the different views: Overview & Allocation, Manage SKU Budgets, and MFC Allocation Tool
 *
 * @param {Object} props
 * @param {Object|null} props.selectedFacility - The currently selected facility
 * @param {string} props.selectedFacility.value - Facility ID or 'ALL'
 * @param {string} props.selectedFacility.label - Display label (e.g., "BWI - Baltimore")
 * @param {string} props.selectedFacility.name - Facility name (e.g., "BWI")
 */
export function NavigationTabs({ selectedFacility }) {
    return (
        <Tabs defaultValue="overview" className="w-full px-12 bg-stone-50">
            <div className="px-6 py-4 text-left">
                <TabsList className="h-auto p-0 bg-stone-100">
                    <TabButton value="overview">Overview & Allocation</TabButton>
                    <TabButton value="sku-budgets">Manage SKU Budgets</TabButton>
                    <TabButton value="mfc-allocation">MFC Allocation Tool</TabButton>
                </TabsList>
            </div>

            <div className="px-6 py-2">
                <TabsContent value="overview">
                    <OverviewAllocation selectedFacility={selectedFacility} />
                </TabsContent>

                <TabsContent value="sku-budgets">
                    <ManageSKUBudgets selectedFacility={selectedFacility} />
                </TabsContent>

                <TabsContent value="mfc-allocation">
                    <MFCAllocationTool selectedFacility={selectedFacility} />
                </TabsContent>
            </div>
        </Tabs>
    );
}
